// src/data/partnersData.js
import deltaLizingLogo from '../assets/images/delta-lizing.jpg';
import flitAutolizingLogo from '../assets/images/flit-autolizing.jpg';
import ttlLogo from '../assets/images/TTL.jpg';
import renessansLogo from '../assets/images/renessans.jpg';

export function getPartnersData(lang = 'ru') {
  const isRu = lang === 'ru' || lang.startsWith('ru');
  const isZh = lang === 'zh' || lang.startsWith('zh');
  const isEn = !isRu && !isZh;

  // Русская версия
  if (isRu) {
    return [
      {
        id: 1,
        slug: 'delta-lizing',
        name: 'Лизинговая компания',
        short_description: 'ООО "Дельта Лизинг" – универсальная лизинговая компания. Опыт работы на Российском рынке лизинговых услуг с 2011 года.',
        description: 'ООО "Дельта Лизинг" – универсальная лизинговая компания. Опыт работы на Российском рынке лизинговых услуг с 2011 года. Больше 10 лет мы растем вместе с Российскими предпринимателями, помогая развиваться нашим партнерам, непрерывно развиваясь самостоятельно, мы реализовали множество не стандартных больших и малых проектов.\n\nМы специализируемся на Финансировании любых транспортных средствах, спецтехники, оборудования и коммерческой недвижимости. Наши клиенты – это предприниматели и предприятия, зарегистрированные на территории РФ.\n\nЦель Дельта Лизинг – помочь предпринимателю заработать на своём деле, не отвлекаясь на не профильные задачи.',
        logo: deltaLizingLogo
      },
      {
        id: 2,
        slug: 'flit-avtolizing',
        name: 'Лизинговая компания',
        short_description: 'ООО «Флит Автолизинг» — лизинговая компания, которая предоставляет услуги финансового лизинга легкового, грузового и коммерческого автотранспорта.',
        description: 'ООО «Флит Автолизинг» — лизинговая компания, которая предоставляет услуги финансового лизинга легкового, грузового и коммерческого автотранспорта, а также спецтехники, оборудования и коммерческой недвижимости. Входит в состав российского лизингового операционного холдинга ООО «ФЛИТ».\n\nИмеет рейтинг A-(RU) от АКРА с прогнозом «Стабильный». ООО «Флит Автолизинг» - это индивидуальный подход к каждому клиенту и гибких графиков платежей',
        logo: flitAutolizingLogo
      },
      {
        id: 3,
        slug: 'tehtranslizing',
        name: 'Техтранслизинг',
        short_description: 'Ваш надёжный партнер в решении инвестиционных задач',
        description: 'Ваш надёжный партнер в решении инвестиционных задач\n\nБолее 20-ти лет мы успешно поставляем клиентам всю линейку лизинговых продуктов: легковые, грузовые, коммерческие автомобили, специальный транспорт для перевозки опасных грузов, медицинские, пожарные, бронированные автомобили, строительную, коммунальную, уборочную технику, все виды общественного транспорта, недвижимости и оборудование. Мы сотрудничаем с крупными и динамично-развивающимися компаниями. Наши партнеры работают в различных областях и направлениях бизнеса.\n\nЗа время деятельности на рынке лизинговых услуг компанией отработаны все аспекты лизинговых операций: финансовые, юридические, налоговые, страховые. Гибкость и индивидуальный подход минимизируют финансовые и временные затраты наших клиентов и обеспечивают эффективное управление проектом в течение всего времени сотрудничества.\n\nТехтранслизинг - Ваш надёжный партнер на пути успеха!',
        logo: ttlLogo
      },
      {
        id: 4,
        slug: 'renessans',
        name: 'РЕНЕССАНС',
        short_description: 'Крупнейший независимый страховщик России',
        description: 'Крупнейший независимый страховщик России\n\nТехнологичная компания, инноватор страхового рынка России\n\nС помощью инновационных продуктов, сервисов и коммуникаций мы делаем мир для наших клиентов безопаснее и комфортнее.\n\nЭффективно используя опыт, накопленный за более чем 25 лет, мы постоянно находимся в поиске новых решений, чтобы обеспечить клиентам лучший сервис.',
        logo: renessansLogo
      }
    ];
  }

  // Английская версия
  if (isEn) {
    return [
      {
        id: 1,
        slug: 'delta-lizing',
        name: 'Leasing Company',
        short_description: 'Delta Leasing LLC is a universal leasing company. Operating in the Russian leasing services market since 2011.',
        description: 'Delta Leasing LLC is a universal leasing company. Operating in the Russian leasing services market since 2011. For over 10 years, we have been growing alongside Russian entrepreneurs, helping our partners develop while continuously evolving ourselves, implementing numerous non-standard large and small projects.\n\nWe specialize in financing any vehicles, special equipment, machinery, and commercial real estate. Our clients are entrepreneurs and enterprises registered in the Russian Federation.\n\nDelta Leasing\'s goal is to help entrepreneurs earn from their business without being distracted by non-core tasks.',
        logo: deltaLizingLogo
      },
      {
        id: 2,
        slug: 'flit-avtolizing',
        name: 'Leasing Company',
        short_description: 'Flit Avtolizing LLC is a leasing company providing financial leasing services for passenger, cargo, and commercial vehicles.',
        description: 'Flit Avtolizing LLC is a leasing company providing financial leasing services for passenger, cargo, and commercial vehicles, as well as special equipment, machinery, and commercial real estate. Part of the Russian leasing operational holding FLIT LLC.\n\nHolds an A-(RU) rating from ACRA with a "Stable" outlook. Flit Avtolizing offers an individual approach to each client and flexible payment schedules.',
        logo: flitAutolizingLogo
      },
      {
        id: 3,
        slug: 'tehtranslizing',
        name: 'Tehtranslizing',
        short_description: 'Your reliable partner in solving investment challenges',
        description: 'Your reliable partner in solving investment challenges\n\nFor over 20 years, we have been successfully supplying clients with the full range of leasing products: passenger, cargo, commercial vehicles, special transport for hazardous goods, medical, fire, armored vehicles, construction, municipal, cleaning equipment, all types of public transport, real estate, and equipment. We cooperate with large and dynamically developing companies. Our partners work in various fields and business directions.\n\nDuring our time in the leasing services market, the company has worked out all aspects of leasing operations: financial, legal, tax, insurance. Flexibility and an individual approach minimize the financial and time costs of our clients and ensure effective project management throughout the entire cooperation period.\n\nTehtranslizing - Your reliable partner on the path to success!',
        logo: ttlLogo
      },
      {
        id: 4,
        slug: 'renessans',
        name: 'RENAISSANCE',
        short_description: 'Russia\'s largest independent insurer',
        description: 'Russia\'s largest independent insurer\n\nA technology company, an innovator in the Russian insurance market\n\nWith innovative products, services, and communications, we make the world safer and more comfortable for our clients.\n\nEffectively using the experience accumulated over more than 25 years, we are constantly searching for new solutions to provide clients with the best service.',
        logo: renessansLogo
      }
    ];
  }

  // Китайская версия
  return [
    {
      id: 1,
      slug: 'delta-lizing',
      name: '租赁公司',
      short_description: 'Delta Leasing有限责任公司是一家综合性租赁公司。自2011年以来在俄罗斯租赁服务市场运营。',
      description: 'Delta Leasing有限责任公司是一家综合性租赁公司。自2011年以来在俄罗斯租赁服务市场运营。10多年来，我们与俄罗斯企业家共同成长，帮助我们的合作伙伴发展，同时不断自我发展，实施了许多非标准的大小项目。\n\n我们专注于为任何车辆、特种设备、机械和商业房地产提供融资。我们的客户是在俄罗斯联邦注册的企业家和企业。\n\nDelta Leasing的目标是帮助企业家从他们的业务中赚钱，而不被非核心任务分心。',
      logo: deltaLizingLogo
    },
    {
      id: 2,
      slug: 'flit-avtolizing',
      name: '租赁公司',
      short_description: 'Flit Avtolizing有限责任公司是一家租赁公司，提供乘用车、货车和商用车的金融租赁服务。',
      description: 'Flit Avtolizing有限责任公司是一家租赁公司，提供乘用车、货车和商用车的金融租赁服务，以及特种设备、机械和商业房地产。是俄罗斯租赁运营控股公司FLIT有限责任公司的一部分。\n\n拥有ACRA的A-(RU)评级，展望为"稳定"。Flit Avtolizing为每位客户提供个性化方法和灵活的付款计划。',
      logo: flitAutolizingLogo
    },
    {
      id: 3,
      slug: 'tehtranslizing',
      name: 'Tehtranslizing',
      short_description: '您解决投资挑战的可靠合作伙伴',
      description: '您解决投资挑战的可靠合作伙伴\n\n20多年来，我们成功地为客户提供全系列租赁产品：乘用车、货车、商用车、危险品运输专用车、医疗、消防、装甲车、建筑、市政、清洁设备、各类公共交通、房地产和设备。我们与大型和快速发展的公司合作。我们的合作伙伴在各个领域和业务方向工作。\n\n在租赁服务市场的活动期间，公司已经完善了租赁业务的所有方面：财务、法律、税务、保险。灵活性和个性化方法最大限度地减少了客户的财务和时间成本，并确保在整个合作期间有效管理项目。\n\nTehtranslizing - 您成功之路上的可靠合作伙伴！',
      logo: ttlLogo
    },
    {
      id: 4,
      slug: 'renessans',
      name: 'RENAISSANCE',
      short_description: '俄罗斯最大的独立保险公司',
      description: '俄罗斯最大的独立保险公司\n\n一家技术公司，俄罗斯保险市场的创新者\n\n通过创新产品、服务和沟通，我们让客户的世界更安全、更舒适。\n\n有效利用25年多积累的经验，我们不断寻找新的解决方案，为客户提供最好的服务。',
      logo: renessansLogo
    }
  ];
}
